// Base58 + Base58Check decoder for Bitcoin addresses

import { doubleSha256 } from "./sha256";

const ALPHABET = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
export const BASE58_CHARS = new Set(ALPHABET);

const MAP = new Map();
for (let i = 0; i < ALPHABET.length; i++) MAP.set(ALPHABET[i], i);

export function base58Decode(str) {
  if (typeof str !== "string" || str.length === 0) return null;

  // Count leading '1' chars (each represents a leading zero byte)
  let zeros = 0;
  while (zeros < str.length && str[zeros] === "1") zeros++;

  const bytes = [];
  for (let i = zeros; i < str.length; i++) {
    const val = MAP.get(str[i]);
    if (val === undefined) return null;
    let carry = val;
    for (let j = 0; j < bytes.length; j++) {
      carry += bytes[j] * 58;
      bytes[j] = carry & 0xff;
      carry >>>= 8;
    }
    while (carry > 0) {
      bytes.push(carry & 0xff);
      carry >>>= 8;
    }
  }

  const out = new Uint8Array(zeros + bytes.length);
  for (let i = 0; i < bytes.length; i++) out[zeros + i] = bytes[bytes.length - 1 - i];
  return out;
}

// Verify Base58Check encoded string: trailing 4 bytes must equal first 4 bytes of dSHA256(payload).
// Returns the payload bytes (including version byte) on success, null on failure.
export function base58CheckDecode(str) {
  const decoded = base58Decode(str);
  if (!decoded || decoded.length < 5) return null;
  const payload = decoded.subarray(0, decoded.length - 4);
  const checksum = decoded.subarray(decoded.length - 4);
  const hash = doubleSha256(payload);
  for (let i = 0; i < 4; i++) {
    if (hash[i] !== checksum[i]) return null;
  }
  return payload;
}
